import React from "react";
import { Outlet } from "react-router-dom";

function Navigate() {
  return <Outlet />;
}
export default Navigate;
